import { combineReducers } from 'redux';
import { localizeReducer } from 'react-localize-redux';

import session from './session';
import destination from './destination';
import deviations from './deviation';
import serviceReport from './servicereport';
import workList from './worklist';
import navbar from './navbar';
import customer from './customer';
import { SESSION_LOGOUT } from '../actions/session';

const createRootReducer = () => {
  const mainReducer = combineReducers({
    locale: localizeReducer,
    session,
    destination,
    deviations,
    serviceReport,
    workList,
    navbar,
    customer,
  });

  return (state, action) => {
    let newState = state;

    if (action.type === SESSION_LOGOUT) {
      const { locale } = state || {};
      newState = { locale };
    }

    return mainReducer(newState, action);
  };
};

export default createRootReducer;
